export enum Currency {
  Eur = 'Eur', // Euro
  Sek = 'Sek', // Swedish Krona
  Usd = 'Usd', // US Dollar
  Nok = 'Nok', // Norwegian Krone
  Jpy = 'Jpy', // Japanese Yen
  Cad = 'Cad', // Canadian Dollar
  Chf = 'Chf', // Swiss Franc
  Brl = 'Brl', // Brazilian Real
  Dkk = 'Dkk', // Danish Krone
  Gbp = 'Gbp', // British Pound Sterling
  Aud = 'Aud', // Australian Dollar
  Cny = 'Cny', // Chinese Yuan Renminbi
  Inr = 'Inr', // Indian Rupee
  Mxn = 'Mxn', // Mexican Peso
  Pln = 'Pln', // Polish Zloty
  Hkd = 'Hkd', // Hong Kong Dollar
  Krw = 'Krw', // South Korean Won
  Sgd = 'Sgd', // Singapore Dollar
  Try = 'Try', // Turkish Lira
  Zar = 'Zar', // South African Rand
  Rub = 'Rub', // Russian Ruble
  Nzd = 'Nzd', // New Zealand Dollar
}
